import { PageDatum } from '@/src/pages/homepage/shopLandingPage/conponent';
import { lxShopStatus } from '@/components/HomePage/LandingPage/ItemCardV2/constan';

const Statistics = Mach.requireModule('Statistics');
const CID = 'c_waimai_c_overseas_uvyhshpd';

interface Value {
  [key: string]: any;
}

const mv = (bid: string, val: Value = {}) => {
  Statistics.view(CID, bid, val);
};

const mc = (bid: string, val: Value = {}) => {
  Statistics.click(CID, bid, val);
};

export const pressItemCancleFavoriteMC = (shopId) => {
  mc('b_waimai_c_overseas_rq9le2kw_mc', {
    shop_id: shopId
  });
};

export const pressItemCancleFavoriteMV = (shopId) => {
  mv('b_waimai_c_overseas_rq9le2kw_mv', {
    shop_id: shopId
  });
};

export const favoriteItemMV = (val) => {
  mv('b_waimai_c_overseas_8dlxduq2_mv', val);
};

export const favoriteItemMC = (val) => {
  mc('b_waimai_c_overseas_8dlxduq2_mc', val);
};
